import { render, staticRenderFns } from "./TuanList.vue?vue&type=template&id=f890fddc&scoped=true&"
import script from "./TuanList.vue?vue&type=script&lang=js&"
export * from "./TuanList.vue?vue&type=script&lang=js&"
import style0 from "./TuanList.vue?vue&type=style&index=0&id=f890fddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f890fddc",
  null
  
)

export default component.exports